import { gql } from '@apollo/client';

export const MessageFragment = gql`
  fragment Message on Message {
    id
    isRead: is_read
    message
    sender
    course
  }
`;
